import {Injectable} from '@angular/core';
import {ActiveBetreuerStore} from '@app/core/state/active-betreuer/active-betreuer.store';
import {select} from "@ngneat/elf";
import {toBoolean} from "@app/core/util/check.util";

@Injectable({providedIn: 'root'})
export class ActiveBetreuerQuery {

  isLoading$ = this.store.data.pipe(select(sessionStore => toBoolean(sessionStore.loading)));
  isErrorLoading$ = this.store.data.pipe(select(sessionStore => toBoolean(sessionStore.errorLoading)));
  currentBetreuer$ = this.store.data.pipe(select(sessionStore => sessionStore.betreuer));

  constructor(protected store: ActiveBetreuerStore) {
  }

}
